/* ============================================
   COLDAYS FOOTER - JAVASCRIPT
   Handles Accordion Auto-Close on Mobile
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(accordion => {
    const summary = accordion.querySelector('summary');
    
    summary.addEventListener('click', (e) => {
      // Close other opened accordions
      accordions.forEach(otherAccordion => {
        if (otherAccordion !== accordion && otherAccordion.hasAttribute('open')) {
          otherAccordion.removeAttribute('open');
        }
      });
    });
  });
});